import axios from 'axios';
import {AdminNewsFormValues, NewsCategory} from '../Types/news';
import {ApiResponse} from '../../../types/types';
import {News} from '../Types/type';

const BASE_NEWS_ROUTE: string = 'api/news';
const CATEGORIES_NEWS: string = 'api/news/categories';

export const getAllNews = async (): Promise<ApiResponse<News[]>> => {
  const response = await axios.get(BASE_NEWS_ROUTE);

  return response.data;
};

export const postNews = async (newsInfo: AdminNewsFormValues): Promise<void> => {
  await axios.post(BASE_NEWS_ROUTE, newsInfo);
};

export const putNews = async (
  newsInfo: Partial<AdminNewsFormValues> & {id: number}
): Promise<void> => {
  await axios.put(`/api/news/${newsInfo.id}`, newsInfo);
};

export const deleteNews = async (id: number): Promise<boolean> => {
  try {
    await axios.delete(`/api/news/${id}`);
  } catch (e) {
    return false;
  }
  return true;
};

export const getNewsCategories = async (): Promise<NewsCategory[]> => {
  const {data} = await axios.get<NewsCategory[]>(CATEGORIES_NEWS);

  return data;
};
